import type { FC, ReactNode } from 'react'

import { Quote } from 'lucide-react'
import { SectionHeading } from '@/components/landing/section-heading'
import { MEMBER_VOICES } from '@/constants/landing'

export const VoicesSection: FC = (): ReactNode => {
    return (
        <section id='voices' aria-labelledby='voices-title' className='relative isolate overflow-hidden bg-sand/55 py-24 sm:py-32'>
            <div aria-hidden='true' className='absolute inset-0 -z-10'>
                <div className='ambient-orb -left-24 top-1/4 size-[24rem] bg-gold/25' />
                <div className='ambient-orb -right-20 bottom-0 size-[28rem] bg-champagne/80 [animation-delay:-7s]' />
            </div>

            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <SectionHeading
                    id='voices-title'
                    eyebrow="From Le Cercle"
                    title={<>In the words of <em className='text-gilded'>our members</em></>}
                />

                <ul className='mt-14 grid gap-5 lg:grid-cols-3'>
                    {MEMBER_VOICES.map((voice) => (
                        <li key={voice.name}>
                            <figure className='glass reveal flex h-full flex-col rounded-[2rem] p-8 text-espresso'>
                                <Quote className='size-6 text-gold-deep' strokeWidth={1.3} aria-hidden='true' />

                                <blockquote className='mt-6 flex-1 font-heading text-[1.6rem] font-light leading-snug'>
                                    “{voice.quote}”
                                </blockquote>

                                <figcaption className='mt-8 flex items-center gap-4 border-t border-espresso/10 pt-6'>
                                    <span aria-hidden='true' className='flex size-11 items-center justify-center rounded-full bg-espresso font-heading text-base text-champagne'>
                                        {voice.initials}
                                    </span>

                                    <span>
                                        <span className='block text-sm font-medium'>
                                            {voice.name}
                                        </span>

                                        <span className='block text-xs text-muted-foreground'>
                                            {voice.detail}
                                        </span>
                                    </span>
                                </figcaption>
                            </figure>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    )
}
